import { PaymentMethod } from '../../../../../../../../../../../services/exports/Constants';

export default {
  title: 'Métodos de pagamento',
  payment_options: {
    [PaymentMethod.Card]: 'Cartão de crédito',
  },
};
